import {
  colorBackgroundDefault,
  colorBrandSecondaryBoldest,
  colorContentDim,
} from '@duxton-web/design-tokens/themes/light';
import { Avatar, Divider, Dropdown, Flex, Typography } from '@duxton-web/ui';
import i18n from 'i18n-js';
import { userLogout } from 'omega-rtc/actions/user';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BannerMessage from './BannerMessage';

const MENU_ITEM_KEY = {
  USER_NAME: 'USER_NAME',
  LOGOUT: 'LOGOUT',
};

export const TopNav: React.FunctionComponent = () => {
  const isLoggedIn = useSelector((state) => state.app.isLoggedIn);
  const user = useSelector((state) => state.app.user);
  const dispatch = useDispatch();

  const userName = useMemo(() => (user && user.name) || '', [user]);
  const firstCharacterOfName = useMemo(
    () => userName.slice(0, 1).toUpperCase(),
    [userName],
  );

  const menuItems = useMemo(() => {
    return [
      {
        key: MENU_ITEM_KEY.USER_NAME,
        disabled: true,
        label: (
          <Typography.Metadata style={{ color: colorContentDim }}>
            Logged in as <br /> {userName}
          </Typography.Metadata>
        ),
      },
      {
        key: MENU_ITEM_KEY.LOGOUT,
        label: (
          <Typography.Body level={2}> {i18n.t('nav.logout')}</Typography.Body>
        ),
      },
    ];
  }, [userName]);

  const handleMenuItemClick = ({ key }) => {
    switch (key) {
      case MENU_ITEM_KEY.LOGOUT:
        dispatch(userLogout());
        break;
      default:
        break;
    }
  };

  if (!isLoggedIn) return null;

  return (
    <aside className="-topbar">
      <BannerMessage />

      <Flex
        align="center"
        justify="flex-end"
        gap={16}
        style={{
          padding: 16,
          backgroundColor: colorBackgroundDefault,
        }}
      >
        <Dropdown
          trigger={['click']}
          menu={{
            items: menuItems,
            onClick: handleMenuItemClick,
          }}
        >
          <Avatar shape="circle" size="small" style={{ cursor: 'pointer' }}>
            <Typography.Body
              level={3}
              style={{ color: colorBrandSecondaryBoldest }}
            >
              {firstCharacterOfName}
            </Typography.Body>
          </Avatar>
        </Dropdown>
      </Flex>

      <Divider style={{ margin: 0 }} />
    </aside>
  );
};

export default TopNav;
